const ContactUS = () => {
  return (
    <>
      <div
        className="container"
        style={{ minHeight: "100vh", paddingTop: "10px" }}
      >
        <section className="mb-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 pt-5">
            <div>
              <h3 className="text-2xl font-semibold mb-4">Our Location</h3>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m8!1m3!1d2069.9149798864682!2d76.703797!3d30.7250895!3m2!1i1024!2i768!4f13.1!4m6!3e3!4m0!4m3!3m2!1d30.7250549!2d76.70623239999999!5e1!3m2!1sen!2sin!4v1741605874247!5m2!1sen!2sin"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
              <p className="text-gray-700 text-lg leading-relaxed mt-4 font-bold mb-3">
                Plot no. C2, Industrial area, Phase 1, Sector 57, Mohali
                Village, Sahibzada Ajit Singh Nagar, Punjab 160055
              </p>
              <p className="text-gray-700 text-lg leading-relaxed">
                <b>Email: </b>gillsonmedia21@gmail.com
              </p>
              <p className="text-gray-700 text-lg leading-relaxed">
                <b>Phone: </b>+91 9872005082
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-semibold mb-4">Send Us a Message</h3>
              <form className="space-y-4">
                <div>
                  <label className="block text-gray-700">Name</label>
                  <input
                    type="text"
                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    required
                  />
                </div>
                <div>
                  <label className="block text-gray-700">Email</label>
                  <input
                    type="email"
                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    required
                  />
                </div>
                <div>
                  <label className="block text-gray-700">Message</label>
                  <textarea
                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    rows="4"
                    required
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="w-full bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ContactUS;
